


  
  

  var faActiveCampaign = {
    prefix: 'fak',
    iconName: 'active-campaign',
    icon: [
      512,
      512,
      [],
      'e001',
      
      'M224.4 277.4c8.1 0 16.1-3.1 24.8-9.6c10.2-7.1 19.2-13 19.2-13l3.1-2.2-3.1-2.2c-1.2-.9-136.2-94.6-150.2-103.6c-6.5-4.6-14-5.6-19.9-2.8c-5.6 2.8-8.7 8.7-8.7 15.8v32l1.2 .6c.9 .6 93.7 65.2 111.7 77.2c7.5 5.3 14.6 7.7 21.7 7.7zm180.9-56.2c-8.1-5.9-297.6-207.9-310-216.6l-4-2.8v49.6c0 15.8 8.4 21.7 18.6 29.2c0 0 222.2 154.8 249.8 173.8c-27.6 19.2-236.7 164.1-250.1 172.5c-15.8 10.6-17.4 17.4-17.4 31.6V512s306.2-219.1 312.8-224h0c14-10.6 17.1-23 17.4-32v-5.6c.3-11.2-5.6-21.1-17.1-29.2z'
      
    ]
  };

  

  
  

  var faClickFunnels = {
    prefix: 'fak',
    iconName: 'click-funnels',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M482.3 42.8H29.7C13.6 42.8 .4 56 .4 72.1v367.8c0 16 13.2 29.2 29.2 29.2h452.6c16 0 29.2-13.2 29.2-29.2V72.1c0-16-13.2-29.2-29.2-29.2zM454.7 70.9c10.2 0 18.7 8.4 18.7 18.7s-8.4 18.7-18.7 18.7-18.7-8.4-18.7-18.7 8.4-18.7 18.7-18.7zm-66.5 0c10.2 0 18.7 8.4 18.7 18.7s-8.4 18.7-18.7 18.7-18.7-8.4-18.7-18.7 8.4-18.7 18.7-18.7zm-66.5 0c10.2 0 18.7 8.4 18.7 18.7s-8.4 18.7-18.7 18.7-18.7-8.4-18.7-18.7 8.4-18.7 18.7-18.7zM474 431.3H37.7V133.4H474v297.9zM173.8 399.6c6.1-10.2 18.4-15.1 29.9-12c10.6 3.7 22.1-1.9 25.8-12.5c.1-.2 .2-.4 .2-.6c4.1-10.9-1.2-23-12-27.5c-10.4-4.8-16.3-16-14.3-27.3c1.9-11.8 11.9-20.6 23.8-20.9c11.8-.3 21.3-9.9 21.3-21.7c-.1-12-9.7-21.6-21.7-21.7h-.4c-12-.4-22.1-8.9-24.5-20.7c-.6-3.5-.6-7 0-10.5c1.2-7.7 6.1-14.4 13.2-17.9c10.2-5.5 14.3-18.1 9.2-28.6c-3.8-11.1-15.9-17-27.1-13.2c-5.4 2.2-11.4 2.3-16.9 .5c-4.7-2.1-8.9-5.4-12-9.6c-4.7-6.3-6.6-14.4-5-22.1H63.9c46.2 24.8 90.2 74.7 91.3 140.8c1.2 71.7-36.8 129.6-92.6 157.1H175c-7.7-9-8.2-22-1.2-31.6zM314.4 162.1c9.2 7.6 11.9 20.7 6.3 31.4c-4.5 11.1-15.9 17.7-27.8 16.3c-11-2.1-21.7 5.1-23.8 16.2c-.1 .3-.1 .5-.1 .8c-2.4 11.3 4.5 22.5 15.7 25.4c11 3.1 18.6 13.3 18.3 24.7c-.2 11.6-8.4 21.6-19.8 23.9c-10.4 1.8-18 10.8-18 21.4c.1 12 9.7 21.7 21.7 21.7c1.2 0 2.5-.1 3.7-.3c11.9-1.5 23.2 5.4 27.4 16.7c1.2 3.3 1.7 6.8 1.6 10.3c0 7.9-3.8 15.3-10.2 19.9c-9.4 7-11.5 20.3-4.8 29.9c2.9 4.6 7.1 8.3 12 10.8h133c-42.3-21-81.6-60.4-91.3-116.5c-13.6-79.6 23.9-148.9 86.9-181.2H309.6c-6.3 9.3-4.2 22 4.8 28.7zm38.3 273.4h-3.9c1.3 .4 2.6 .4 3.9 0z'
      
    ]
  };

  

  
  

  var faConstantContact = {
    prefix: 'fak',
    iconName: 'constant-contact',
    icon: [
      512,
      512,
      [],
      'e000',
      
      'M236.8 512C95.8 512 0 397 0 274.8C0 150.8 97.7 43.6 227.7 38.6c5-.3 9.4 4.1 9.4 9.1v38c0 4.7-3.8 8.8-8.8 9.1c-95.5 4.4-172.4 82.6-172.4 180.3c0 95.5 75.4 180.9 180.9 180.9c102.7 0 175.6-82 180-172.4c.3-4.7 4.1-8.8 9.1-8.8h38c5 0 9.1 4.1 9.1 9.4c-4.4 120.6-101.4 227.7-236.2 227.7zm.3-125.7c-62.8 0-111.5-50-111.5-111.5c0-57.5 44.3-105.5 101.8-110.2c5.3-.3 9.7 3.8 9.7 9.1v38c0 4.4-3.1 8.5-7.8 9.1c-27.6 3.8-47.7 27.3-47.7 54.3c0 30.1 23.6 55.6 55.6 55.6c26.7 0 50.6-20.1 54.3-47.7c.6-4.4 4.7-7.8 9.1-7.8h38c5.3 0 9.4 4.4 9.1 9.7c-5 56.2-52.1 101.4-110.6 101.4zm218.9-158c-4.4-92-77.9-168-172.4-172.4c-4.7-.3-8.8-4.1-8.8-9.1V9.1c0-5 4.1-9.1 9.4-9.1c122.8 4.7 223 103 227.7 227.7c.3 5-4.1 9.4-9.1 9.4h-38c-4.4 0-8.5-3.8-8.8-8.8zM285.2 182.5c-5.7-.9-9.7-5.7-9.7-10.4v-37.1c0-5.3 4.4-9.4 9.7-9.1c54.7 4.7 96.7 48.4 101.4 101.2c.3 5.3-3.8 9.7-9.1 9.7h-39.9c-3.8 0-6.6-2.5-7.2-6.3c-2.8-22.3-19.8-43.6-45.2-48.1z'
      
    ]
  };

  

  
  

  var faVamp = {
    prefix: 'fak',
    iconName: 'vamp',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M322.2 494.9c-3 0-6-.4-9-1.2c-15.9-4.2-24.7-18.4-19.7-31.7L451.7 35.6c5-13.3 21.8-20.8 37.7-16.6c15.9 4.2 24.7 18.4 19.7 31.7L350.9 477.1c-4 10.8-15.9 17.8-28.7 17.8zM198.8 493c15.9-4.2 24.7-18.4 19.7-31.7L60.3 34.9c-5-13.3-21.8-20.8-37.7-16.6C6.8 22.4-2.1 36.6 2.8 50l158.2 426.4c4 10.8 15.9 17.8 28.7 17.8c3 0 6-.4 9-1.2z'
      
    ]
  };

  



export {

  faActiveCampaign,
  

  faClickFunnels,
  

  faConstantContact,
  

  faVamp,
  

};
